import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { OrganizationStatus } from 'src/app/common';
import { Utility } from 'src/app/core/common';
import { OrganizationService } from 'src/app/services/organization.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.scss']
})
export class OrganizationComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router, private organizationService: OrganizationService) { }

  OrganizationStatus = OrganizationStatus;
  Utility = Utility;
  tags: string[];
  list: any[];
  total: number;
  criteria: any = {};
  limit = 30;
  from = 0;
  selected: any;
  @ViewChild('organizationModal') organizationModal: NgxSmartModalComponent;

  async ngOnInit() {
    this.route.queryParams.pipe(switchMap(async params => await this.load(params)))
      .pipe(takeUntil(this.unsubscribe$)).subscribe();
  }
  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async load(params?: any) {
    if (params) {
      this.limit = params.limit || this.limit;
      this.criteria = {
        Keyword: params.q,
        Query: params.query,
        Status: params.status ? +params.status : undefined,
      };
      this.from = params.from || 0;
    }

    var result = await this.organizationService.search(this.criteria);
    this.list = result.List;
    this.total = result.Total;
    this.tags = await this.organizationService.tags();
  }

  newOrganization() {
    this.selected = {};
    this.organizationModal.open();
  }

  image: File;
  preview: string | ArrayBuffer;
  imageUrl = environment.app.filesUrl;
  loadImage(image: File) {
    const reader = new FileReader();
    reader.readAsDataURL(image);
    reader.onload = () => this.preview = reader.result;
    this.image = image;
  }
  removeImage(element: HTMLInputElement) {
    delete this.preview;
    delete this.image;
    delete this.selected.Logo;
    element.value = '';
  }
  get currentImage() {
    return this.selected.Logo ? (this.selected.Logo.startsWith('http') ? this.selected.Logo : environment.app.filesUrl + this.selected.Logo) : null;
  }

  async save(organization: any) {
    await this.organizationService.save(organization, this.image ? this.image : true);
    this.organizationModal.close();
    await this.load();
  }

  openEdit(organization: any) {
    this.selected = organization;
    this.organizationModal.open();
  }

  async remove(organization: any) {
    await this.organizationService.remove(organization.Id);
    this.organizationModal.close();
    await this.load()
  }

  suggestVaraiations(organization: any) {
    if (!organization.Variations) organization.Variations = [];

    var array = [organization.Title, organization.TitleEn, ...organization.Variations].filter(_ => !!_);
    for (var item of array) {
      var parts = item.split(/\s|‌/g);
      if (parts.length < 2) continue;
      var spaced = this.addSpace(parts);
      if (parts.filter(_ => _.length == 1).length)
        spaced.push(...this.addSpace(parts.filter(_ => _.length > 1)));
      organization.Variations.push(...spaced.filter(_ => !organization.Variations.includes(_) && !array.includes(_)));
    }
  }
  addSpace(array: string[]) {
    if (array.length == 1) return array;
    return Utility.flat([array[0] + array[1], array[0] + ' ' + array[1], array[0] + '‌' + array[1]]
      .map(f => this.addSpace([f, ...array.slice(2)])));
  }


  navigate(key: string, value: any) {
    let params = { ...this.route.snapshot.queryParams };
    params['from'] = 0;
    params[key] = value;
    this.router.navigate([], { queryParams: params, queryParamsHandling: 'merge', relativeTo: this.route });
  }
}
